<template>
  <div>
    <div class="p-t-none">
      <div class="tituloBox">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Sócios</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="dadosBasicosSocioDirigente.concat(cabecalhoSocios)"
      :items="sociosLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.nome }}</td>
        <td class="text-xs-left">
          <input
            v-if="props.item.flagEstrangeiro == 0"
            v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
            readonly
            :value="props.item.cpfCnpj"
          >
          <input
            v-if="props.item.flagEstrangeiro == 1"
            readonly
            :value="props.item.cpfCnpj"
          >
        </td>
        <td class="text-xs-center">{{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}</td>
        <td class="text-xs-center">{{ props.item.percentual }}</td>
        
        <td class="text-xs-center naoImprimir">
          <a 
            v-show="props.item.arquivoUpload && props.item.arquivoUpload !== 'Não Encontrado'"
          >
            <v-icon 
              :color="
                props.item.arquivoUpload.includes('https') 
                  ? 'blue' 
                  : (props.item.arquivoUploadSituacao === 1 && props.item.arquivoUpload.includes('.pdf') 
                    ? 'red' 
                    : 'grey')
              "
              :disabled="!(
                props.item.arquivoUpload.includes('https') || 
                (props.item.arquivoUploadSituacao === 1 && props.item.arquivoUpload.includes('.pdf'))
              )"
                @click.native="handleIconClick(props.item.arquivoUpload,props.item.arquivoUploadSituacao)"
            >
              attach_file
            </v-icon>
          </a>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import fornecedorService from "../../../../services/fornecedorService";
import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "socios-crud",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object
  },

  computed: {//Campos computados
    sociosLista: function() {
      //resgata a lsita de socios
      if(!this.model.fornecedoresHabilitacaoJuridica) return [];
      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "S"
      );
      if (lista.length) return lista;
      else return [];
    }
  },

  created() /*Metodo de start do componente*/{},

  data() {//Declaracao de variaveis
    return {
      totalDesserts: 0,
      loading: false,
    };
  },
  methods: {
    handleIconClick(arquivo,situacao) {
    if (arquivo.includes('https')) {
      window.open(arquivo, '_blank');
    } else if (situacao === 1 && arquivo.includes('.pdf')) {
      this.baixarArquivo(arquivo);
    }
  },  
  
    baixarArquivo(arquivo) {
        //baixar o documento
       
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      }
  }
};
</script>